import { create } from '@thoughtspot/logger';
import { convertPointValToContextMenuInputValue, updateCustomActionOnClickCallback, validateOpenContextMenuEventPayloadObject, } from './util';
const logger = create('context-menu-events');
const validateOpenContextMenuEventPayload = (eventData, columns) => {
    const payload = eventData.payload;
    try {
        validateOpenContextMenuEventPayloadObject(payload, columns);
    }
    catch (err) {
        logger.warn(err);
        return {
            isValid: false,
            errors: [err.toString()],
        };
    }
    return {
        isValid: true,
    };
};
const getOpenContextMenuEventProcessor = (props) => {
    const { chartModel, openContextMenu, iFrameWindow, emitEvent } = props;
    const chartColumns = chartModel.columns.map(col => col.column);
    return {
        validateEventPayload: (eventData) => {
            return validateOpenContextMenuEventPayload(eventData, chartColumns);
        },
        executeEvent: (eventData) => {
            const payload = eventData.payload;
            const { clickedPoint, selectedPoints, customActions, event: inputEvent, } = payload;
            const { x: xPos, y: yPos, } = iFrameWindow.current.getBoundingClientRect();
            const eventObj = {
                ...inputEvent,
                clientX: inputEvent.clientX + xPos,
                clientY: inputEvent.clientY + yPos,
            };
            const convertedClickedPoint = convertPointValToContextMenuInputValue(clickedPoint, chartColumns);
            const convertedSelectedPoints = selectedPoints?.map(point => convertPointValToContextMenuInputValue(point, chartColumns)) ?? [];
            const convertedCustomActions = updateCustomActionOnClickCallback(customActions, emitEvent, clickedPoint, selectedPoints, inputEvent);
            openContextMenu(eventObj, convertedClickedPoint, convertedSelectedPoints, convertedCustomActions);
            return Promise.resolve();
        },
    };
};
const getCloseContextMenuEventProcessor = (props) => {
    const { closeContextMenu } = props;
    return {
        validateEventPayload: (eventData) => {
            return {
                isValid: true,
            };
        },
        executeEvent: (eventData) => {
            closeContextMenu();
            return Promise.resolve();
        },
    };
};
const testHooks = {
    validateOpenContextMenuEventPayload,
};
export { getOpenContextMenuEventProcessor, getCloseContextMenuEventProcessor, testHooks, };
//# sourceMappingURL=index.js.map